import { updateDominioPrincipal } from '../globalslice';

const findDomainPrincipal = (item) => {
    if (
        item &&
        item.product &&
        item.product.domain_section &&
        item.product.domain_section.length > 0
    ) {
        return item.product.domain_section[0].dominio_principal;
    }
    return null;
};

export const removeDomainFromService = (ResumenData, data, dispatch) => {
    let domainToDelete = null;

    // Encontrar el elemento relacionado
    const itemToRemove = ResumenData.find((item) => item.id === data.id);
    if (itemToRemove) {
        domainToDelete = findDomainPrincipal(itemToRemove);
    }

    const remainingServices = ResumenData.filter((item) => item.id !== data.id);
        // Es un dominio principal relacionado al servicio
        remainingServices.forEach((item) => {
            if (item.type !== "domain") {
                const relatedDomain = findDomainPrincipal(item);

                if (relatedDomain === domainToDelete) {
                    dispatch(updateDominioPrincipal({ id: item.id, dominioPrincipal: null, domainType: null }));
                }
            }
        });
};
